import React from 'react';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { DashboardStats } from '../components/dashboard/DashboardStats';
import { AutoMigrationNotification } from '../components/common/AutoMigrationNotification';

export const DashboardPage: React.FC = () => {
  // Antes esta página llamaba a useDashboardStats solo para leer su isLoading, que era
  // siempre false: el hook disparaba 7 consultas (personal, carteras, clientes, nodos,
  // documentos vencidos, por vencer y cursos) cuyo resultado no se usaba en ninguna parte.
  const { data: currentUser } = useCurrentUser();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50">
      <div className="dashboard-compact">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* Notificación de migración automática */}
        {currentUser?.rut && (
          <AutoMigrationNotification rut={currentUser.rut} showStats={false} />
        )}

        {/* Stats Cards y Gráficos */}
          <div className="slide-up animate-delay-200">
            <DashboardStats />
          </div>

      </div>
      </div>
    </div>
  );
};
